import classNames from 'classnames';
import React from 'react';
import UDText from 'ud-ui/components/text';

export interface UDFilterChipGroupProps {
  /**
   * Имя группы для скринридера (`aria-label`) — обязательно: набор чипов без имени читается как
   * россыпь кнопок. Видимой подписью становится, только если `isLabelVisible`.
   */
  label: string;
  /** Показать `label` слева от чипов жирным. Без него группа всё равно подписана для скринридера. */
  isLabelVisible?: boolean;
  /** Иконка перед видимой подписью; без подписи не рисуется. */
  icon?: React.ReactNode;
  className?: string;
  /** Чипы группы — `UDFilterChip`. «Выбран один» держит экран. */
  children: React.ReactNode;
}

/**
 * Группа фильтр-чипов: `role="group"` с именем, необязательной подписью с иконкой и переносом чипов.
 *
 * Одна обёртка на все экраны: раньше каждый экран писал её заново, и отступы, подпись и доступное
 * имя расходились. Выбор значения и счётчики остаются за экраном — группа их не знает.
 */
const UDFilterChipGroup = ({ label, isLabelVisible = false, icon, className, children }: UDFilterChipGroupProps) => {
  return (
    <div role="group" aria-label={label} className={classNames('flex flex-wrap items-center gap-2', className)}>
      {isLabelVisible && (
        <div className="text-inkSecondary mr-1 flex items-center gap-1.5">
          {icon}
          <UDText type="caption-1" className="text-inkSecondary bold">
            {label}
          </UDText>
        </div>
      )}
      {children}
    </div>
  );
};

export default React.memo(UDFilterChipGroup);
